export default "__VITE_ASSET__ef7a4bad__"